import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetScheduledCommandsList } from "../Responses/GetScheduledCommandsList";

export async function getScheduledCommandsList(data) {
	let response = await getAPIResponse("/command-scheduler/scheduled-commands", data);
	if (response === null) {
		return null;
	}
	let getScheduledCommandsList = GetScheduledCommandsList.createFromResponseData(response);
	return getScheduledCommandsList;
}